import apiPaths from '../api-paths.js';

export default {
  list() {
    return axios.get(`${ apiPaths.PERSON }/status-type/dictionary`);
  },
};